import ActionTypes from '../constants/ActionTypes/index';

export default (error) => {
  return function (dispatch) {
    dispatch({ type: ActionTypes.error.INFO, code: error });
  };
};
